import { render, staticRenderFns } from "./OrderShow.vue?vue&type=template&id=fae0c138&scoped=true"
import script from "./OrderShow.vue?vue&type=script&lang=js"
export * from "./OrderShow.vue?vue&type=script&lang=js"
import style0 from "./OrderShow.vue?vue&type=style&index=0&id=fae0c138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae0c138",
  null
  
)

export default component.exports